import React from 'react';
import { Button, Icon, Form, Header, Segment, Loader, Table, Grid, Popup, Checkbox, Divider } from 'semantic-ui-react';
import axios from 'axios';
import ReactExport from 'react-data-export';
import moment from "moment";
import SearchTableData from "../util/SearchTableData";
import PaginationFront from "../util/PaginationFront";

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class EmployeesByTypeAndAcademicYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            academicYearId: null,
            data:[],
            report: null,
            orgUnit: null,
            orgUnits: [],
            excelData: [],
            disabled: false,
            employeeTypeId: null,
            allTypes: false,
            disabledType: false,

            loaded: null,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            unsa: localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja' || localStorage.getItem('activeRole').substr(0, 13) === 'Administrator',

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.sum = this.sum.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    sum(columnName) {
        this.state.data.map(()=>{
            return
        })
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
        };

        axios.get(this.state.organizationalUnitId === 0 ? `hr-reports/number-of-employees-by-employment-type-and-academic-year/for-university/${this.state.academicYearId}/${this.state.employeeTypeId}/`
            : this.state.unsa ? `hr-reports/number-of-employees-by-employment-type-and-academic-year/by-organizational-unit/${this.state.organizationalUnitId}/${this.state.academicYearId}/${this.state.employeeTypeId}/`
                : `hr-reports/number-of-employees-by-employment-type-and-academic-year/${this.state.academicYearId}/${this.state.employeeTypeId}/`)
            .then(res => {
                this.setState({
                    data: res.data,
                    loaded: true,
                }, ()=>{
                    this.setState({
                        // excelData:  this.state.data.map(el => ([
                        //     { value: el.lastName},
                        //     { value: el.firstName},
                        //     { value: el.mainOrganizationalUnitName},
                        //     { value: el.dateStart},
                        //     { value: el.dateEnd},
                        //     { value: el.mainWorkTime},
                        //     { value: el.position},
                        // ]))
                    })
                });


            });
    }

    sum(columnName) {
        let sum = 0
        this.state.data.map((el)=>{
            sum+= el[columnName]
        })
        return sum;
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData:  this.state.data.map(el => ([
                    { value: el.positionName},
                    { value: el.numberOfRegularEmployees},
                    { value: el.numberOfAssociateEmployees},
                    { value: el.numberOfRegularEmployees + el.numberOfAssociateEmployees},

                ]))});
        }else{
            this.setState({ results,
                excelData:  results.map(el => ([
                    { value: el.positionName},
                    { value: el.numberOfRegularEmployees},
                    { value: el.numberOfAssociateEmployees},
                    { value: el.numberOfRegularEmployees + el.numberOfAssociateEmployees},

                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Pozicija', width: { wpx: 150 } },
                    { title: 'u radnom odnosu', width: { wpx: 150 } },
                    { title: 'spoljni saradnici', width: { wpx: 200 } },
                    { title: 'UKUPNO', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field >
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYearId}
                                onChange={this.handleInputChange}
                                name="academicYearId"
                                options={this.props.academicYears}
                                search
                            />
                        </Form.Field>
                        {this.state.unsa && <Form.Field>
                            <label>Organizaciona jedinica</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite organizacionu jedinicu"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        <Form.Field>
                            <label>Tip osoblja</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite tip osoblja"
                                value={this.state.employeeTypeId}
                                onChange={this.handleInputChange}
                                name="employeeTypeId"
                                options={this.props.employeeTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        {!this.state.unsa && <Form.Field />}
                    </Form.Group>


                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj</Button>

                </Form>
                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={6}>
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['positionName']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile
                                                    filename="Broj zaposlenika u stalnom i dopunskom radnom odnosu po tipu i akademskoj godini"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={multiDataSet} name="Zaposlenici" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={3} >Pozicija</Table.HeaderCell>
                                    <Table.HeaderCell >u radnom odnosu</Table.HeaderCell>
                                    <Table.HeaderCell >spoljni saradnici</Table.HeaderCell>
                                    <Table.HeaderCell >UKUPNO</Table.HeaderCell>


                                </Table.Row>
                                {/* <Table.Row> */}
                                {/*     <Table.HeaderCell colSpan={3} >UKUPNO</Table.HeaderCell> */}
                                {/*     <Table.HeaderCell >{this.sum('positionName')}</Table.HeaderCell> */}
                                {/*     <Table.HeaderCell >{this.sum('numberOfRegularEmployees')}</Table.HeaderCell> */}
                                {/*     <Table.HeaderCell >{this.sum('numberOfAssociateEmployees')}</Table.HeaderCell> */}

                                {/* </Table.Row> */}
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell colSpan={3} verticalAlign="middle" > {el.positionName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfRegularEmployees}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfAssociateEmployees}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfRegularEmployees + el.numberOfAssociateEmployees}</Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/EmployeesByTypeAndAcademicYear.js